var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"94b63b517e124b7abc22f0e76f4ba0fdcd15e2ae"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["breeze@otovo"]={id:"94b63b517e124b7abc22f0e76f4ba0fdcd15e2ae"};
      